import { useCallback, useState } from 'react';

import { type MarketWithGroup } from '../utils.server';

export const useMarkets = (
  marketGroups: Record<string, MarketWithGroup[]>,
  selectedMarketId: number | null,
  setSelectedMarketId: (id: number | null) => void,
) => {
  // Sort by priority if available (legacy behavior), otherwise use object order (new API behavior)
  const orderedGroupEntries = Object.entries(marketGroups).sort(([, groupA], [, groupB]) => {
    const priorityA = groupA[0]?.priority;
    const priorityB = groupB[0]?.priority;

    // If both have priority, sort by it (legacy behavior)
    if (priorityA !== undefined && priorityB !== undefined) {
      return priorityA - priorityB;
    }

    // Otherwise maintain object order (new API behavior)
    return 0;
  });

  const marketGroupNames = orderedGroupEntries.map(([groupName]) => groupName);

  const findGroupForSelectedMarket = () => {
    if (selectedMarketId === undefined) return undefined;

    return orderedGroupEntries.find(([, markets]) =>
      markets.some(market => market.ocMarketId === selectedMarketId),
    )?.[0];
  };

  const initialMarketGroup = findGroupForSelectedMarket() ?? marketGroupNames[0];
  const [selectedMarketGroup, setSelectedMarketGroup] = useState<string>(initialMarketGroup);

  const handleMarketChange = useCallback((marketGroupName: string) => {
    setSelectedMarketGroup(marketGroupName);
    setSelectedMarketId(null);
  }, []);

  return {
    handleMarketChange,
    selectedMarketGroup,
    marketGroupNames,
  };
};
